export default __webpack_public_path__ + "03f6e8f7cf8e2dc827a562236d310c04.svg";